import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';

import { useLogError } from '#client/hooks/useLogError';

import { GET_BANK_ACCOUNT } from '../queries/unitAccount';

export const useBankAccount = () => {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, loading, error, errors, refetch } = useQuery(GET_BANK_ACCOUNT, {
    noThrow: true,
    variables: {
      input: {
        businessEntityUuid
      }
    }
  });

  useLogError(errors, error);

  return {
    data: data?.bankAccount || null,
    loading,
    error: errors?.[0],
    refetch
  };
};
